import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if viewport is mobile-sized
 * @param {number} breakpoint - Max width in pixels to consider mobile (default: 768)
 * @returns {boolean} True if viewport is at or below breakpoint
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${breakpoint}px)`).matches
  );

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = () => setIsMobile(media.matches);

    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, [breakpoint]);

  return isMobile;
}
